<template>
  <div id="CreateClaimReviewAndSubmit" class="bg-light pb-5">
    <div class="col">
      <p class="pl-3 py-4">
        Missing or incomplete information may be cause for claim denial. Verify the information below is accurate and
        click '<strong>Submit</strong>' when you are ready.
      </p>
    </div>
    <div class="col">
      <div class="mx-3 pb-2">
        <h2>CLAIM INFORMATION</h2>
      </div>
      <div class="row mx-3 pb-3">
        <div class="col-lg-4 col-md-12 p-0">
          <div class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Dealer Claim Reference</strong>
            </div>
            <div class="col-lg-6 col-md-6">
              {{ claimDto.CustomerReferenceNumber }}
            </div>
          </div>
          <div v-if="claimDto.ClaimType !== 'ExtraParts'" class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Invoice Number</strong>
            </div>
            <div class="col-lg-6 col-md-6">
              {{ claimDto.InvoiceNumber }}
            </div>
          </div>
          <div v-if="claimDto.ClaimType !== 'ExtraParts'" class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Order Number</strong>
            </div>
            <div class="col-lg-6 col-md-6">
              {{ claimDto.OrderNumber }}
            </div>
          </div>
          <div v-if="claimDto.ClaimType === 'FreightOnly'" class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Expected Freight Credit</strong>
            </div>
            <div class="col-lg-6 col-md-6">
              ${{ claimDto.FreightExpectedCredit }}
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-md-12 p-0">
          <div class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Contact Name</strong>
            </div>
            <div class="col-lg-6 col-md-6">
              {{ claimDto.ContactName }}
            </div>
          </div>
          <div class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Contact Number</strong>
            </div>
            <div class="col-lg-6 col-md-6">
              {{ claimDto.ContactPhone }}
            </div>
          </div>
          <div class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Contact Fax</strong>
            </div>
            <div class="col-lg-6 col-md-6">
              {{ claimDto.ContactFax }}
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12 p-0" style="white-space: nowrap;">
          <div class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Contact Email</strong>
            </div>
            <div class="col-lg-6 col-md-6 word-wrap">
              {{ claimDto.ContactEmail }}
            </div>
          </div>
          <div class="row m-0 pb-2">
            <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
              <strong>Contact Extension</strong>
            </div>
            <div class="col-lg-6 col-md-6">
              {{ claimDto.ContactPhoneExtension }}
            </div>
          </div>
        </div>

        <div v-if="claimDto.ClaimType === 'FreightOnly'" class="row m-0 pb-2">
          <div class="text-xs-left">
            <strong>Comments:</strong>
          </div>
          <div class="col-12" style="word-wrap: break-word;">
            {{ claimDto.FreightComment }}
          </div>
        </div>
      </div>
      <div v-if="claimDto.ClaimType !== 'FreightOnly'" class="mx-3 pb-2">
        <h2>PARTS INFORMATION</h2>
      </div>

      <div v-if="claimDto.ClaimType !== 'FreightOnly'">
        <div
          v-for="(part, partsToClaim) in claimDto.Items"
          :key="partsToClaim"
          class="mx-3 mb-3 bg-white border p-2"
        >
          <div class="row no-gutters">
            <div class="col-lg-4 col-md-12 p-0">
              <div class="row m-0 pb-2">
                <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
                  <strong>Part Number</strong>
                </div>
                <div class="col-lg-6 col-md-6">
                  <PartDetailsLink :oem-part-code="part.OrderedOemPartCode" />
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 p-0">
              <div class="row m-0 pb-2">
                <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
                  <strong>Claim Quantity</strong>
                </div>
                <div class="col-lg-6 col-md-6">
                  {{ part.ReturnQuantity }}
                </div>
              </div>
            </div>

            <div class="col-lg-4 col-md-12 p-0">
              <div class="row m-0 pb-2">
                <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
                  <strong>Description</strong>
                </div>
                <div class="col-lg-6 col-md-6 word-wrap">
                  {{ part.PartDescription }}
                </div>
              </div>
            </div>
          </div>

          <div class="row no-gutters">
            <div v-if="claimDto.ClaimType !== 'ExtraParts'" class="col-lg-4 col-md-12 p-0">
              <div class="row m-0 pb-2">
                <div class="col-lg-6 col-md-6 p-0 text-md-right text-xs-left">
                  <strong>Claim Reason</strong>
                </div>
                <div class="col-lg-6 col-md-6">
                  {{ getContentItem(part.ClaimReason) }}
                </div>
              </div>
            </div>

            <div class="col-lg-8 col-md-12 p-0">
              <div class="row m-0 pb-2">
                <div class="col-lg-3 col-md-6 p-0 text-md-right text-xs-left">
                  <strong>Comments</strong>
                </div>
                <div class="col-lg-9 col-md-6">
                  {{ part.Comments }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PartDetailsLink from "@/components/Elements/PartDetailsLink"
  import { mapGetters } from "vuex";

  export default {
    components: {
      PartDetailsLink
    },
    props: {
      claimDto: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      ...mapGetters([
        "getContentItem",
      ]),
    }
  }
</script>
